// extracted by extract-css-chunks-webpack-plugin
module.exports = {"type":"_2GMChG"};